import React from 'react'

export default () => {
  return (
    <div className="col-md-10 col-lg-8 col-xl-6 text-md-center">
      <h1 className="mb-2">Thank You!</h1>
    </div>
  )
}